import { render } from "./form-select2.vue?vue&type=template&id=349b72fb"
import script from "./form-select2.vue?vue&type=script&lang=js"
export * from "./form-select2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__